import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';

// Primitives
import { UiBadgeComponent } from './primitives/ui-badge/ui-badge.component';
import { UiButtonComponent } from './primitives/ui-button/ui-button.component';
import { UiSearchInputComponent } from './primitives/ui-search-input/ui-search-input.component';
import { UiFilterSelectComponent } from './primitives/ui-filter-select/ui-filter-select.component';

// Sidebar
import { UiSidebarBrandComponent } from './sidebar/ui-sidebar-brand/ui-sidebar-brand.component';
import { UiSidebarSearchComponent } from './sidebar/ui-sidebar-search/ui-sidebar-search.component';
import { UiSidebarNavComponent } from './sidebar/ui-sidebar-nav/ui-sidebar-nav.component';
import { UiSidebarComponent } from './sidebar/ui-sidebar/ui-sidebar.component';

// Header
import { UiBreadcrumbComponent } from './header/ui-breadcrumb/ui-breadcrumb.component';
import { UiAppBadgeComponent } from './header/ui-app-badge/ui-app-badge.component';
import { UiUserMenuComponent } from './header/ui-user-menu/ui-user-menu.component';
import { UiAppHeaderComponent } from './header/ui-app-header/ui-app-header.component';

// Layout
import { UiPageShellComponent } from './layout/ui-page-shell/ui-page-shell.component';

// Cards
import { UiStatCardComponent } from './cards/ui-stat-card/ui-stat-card.component';

// Table
import { UiTableToolbarComponent } from './table/ui-table-toolbar/ui-table-toolbar.component';
import { UiDataTableComponent } from './table/ui-data-table/ui-data-table.component';
import { UiTableActionsComponent } from './table/ui-table-actions/ui-table-actions.component';
import { UiPaginationComponent } from './table/ui-pagination/ui-pagination.component';

// Showcase
import { UiShowcaseComponent } from './showcase/ui-showcase/ui-showcase.component';

// Document Panel
import { UiDocumentPanelShellComponent } from './document-panel/ui-document-panel-shell/ui-document-panel-shell.component';
import { UiApprovalStepperComponent } from './document-panel/ui-approval-stepper/ui-approval-stepper.component';
import { UiFormSectionComponent } from './document-panel/ui-form-section/ui-form-section.component';
import { UiDocumentPanelFooterComponent } from './document-panel/ui-document-panel-footer/ui-document-panel-footer.component';
import { UiDocumentFileUploadComponent } from './document-panel/ui-document-file-upload/ui-document-file-upload.component';
import { UiUnsavedChangesDialogComponent } from './document-panel/ui-unsaved-changes-dialog/ui-unsaved-changes-dialog.component';

const UI_COMPONENTS = [
  UiBadgeComponent,
  UiButtonComponent,
  UiSearchInputComponent,
  UiFilterSelectComponent,
  UiSidebarBrandComponent,
  UiSidebarSearchComponent,
  UiSidebarNavComponent,
  UiSidebarComponent,
  UiBreadcrumbComponent,
  UiAppBadgeComponent,
  UiUserMenuComponent,
  UiAppHeaderComponent,
  UiPageShellComponent,
  UiStatCardComponent,
  UiTableToolbarComponent,
  UiDataTableComponent,
  UiTableActionsComponent,
  UiPaginationComponent,
  UiShowcaseComponent,
  UiDocumentPanelShellComponent,
  UiApprovalStepperComponent,
  UiFormSectionComponent,
  UiDocumentPanelFooterComponent,
  UiDocumentFileUploadComponent,
  UiUnsavedChangesDialogComponent,
];

@NgModule({
  declarations: UI_COMPONENTS,
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ScrollingModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatDialogModule,
  ],
  exports: [
    ...UI_COMPONENTS,
    CommonModule,
    FormsModule,
    ScrollingModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatDialogModule,
  ],
})
export class UiModule {}
